/* eslint-disable no-shadow */

import * as types from '../mutation-types';
import helpers from '../helpers';
import { getImportPresets } from '../../lib/api';

const state = {
  items: {},
};

const mutations = {
  [types.ADD_IMPORT_PRESETS](state, presets) {
    helpers.mutations.createItems(state, presets);
  },
};

const actions = {
  add({ commit }, presets) {
    commit(types.ADD_IMPORT_PRESETS, presets);
  },

  async load({ commit }) {
    const presets = await getImportPresets();

    commit(types.ADD_IMPORT_PRESETS, presets);
  },
};

const getters = {
  get(state) {
    return (id) => state.items[id];
  },

  getAll(state) {
    return Object.keys(state.items).map((id) => state.items[id]);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
};
